import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { store } from "./app/store";
import "./index.css";
import "./tablelist.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import { SnackbarProvider, useSnackbar } from "notistack";
import { clearAllAppData } from "./components/login/Login";

// ─────────────────────────────────────────────────────────
const ServiceWorkerWrapper = () => {
  React.useEffect(() => {
    // Register the service worker
    serviceWorkerRegistration.register({});

    // Handler for messages from the service worker
    const onMessage = (event) => {
      if (event.data?.type === "SET_OFFLINE") {
        localStorage.setItem("isOffLine", "true");
      }
    };

    // Handler for going offline
    const goOffline = () => {
      localStorage.setItem("isOffLine", "true");
      window.location.reload(true);
    };

    // Handler for coming back online
    const goOnline = async () => {
      // Tell the service worker to activate immediately
      if (navigator.serviceWorker?.controller) {
        navigator.serviceWorker.controller.postMessage({
          type: "SKIP_WAITING",
        });
      }

      await clearAllAppData(true);

      // Clear all caches to ensure latest assets are loaded
      // const cacheNames = await caches.keys();
      // await Promise.all(cacheNames.map((name) => caches.delete(name)));

      // Reload the app
      // window.location.reload(true);
    };

    // Attach event listeners
    navigator.serviceWorker.addEventListener("message", onMessage);

    window.addEventListener("offline", goOffline);
    window.addEventListener("online", goOnline);

    // Cleanup on unmount
    return () => {
      navigator.serviceWorker.removeEventListener("message", onMessage);
      
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online", goOnline);
    };
  }, []);

  return null;
};
// ─────────────────────────────────────────────────────────

ReactDOM.render(
  <React.StrictMode>
    <SnackbarProvider maxSnack={4}>
      <Provider store={store}>
        <App />
        <ServiceWorkerWrapper />
      </Provider>
    </SnackbarProvider>
  </React.StrictMode>,
  document.getElementById("root"),
);

reportWebVitals();
